import { Container } from "@mui/material";
import { styled } from "@mui/material/styles";

export const PageContainer = styled(Container)(({ props, theme }) => ({
      margin: "64px 0px 0px 0px",
    [theme.breakpoints.down("md")]: {
      margin: "48px 0px 0px 0px",
    },
  }));